exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Edit-module__wrapper___phSAW{display:grid;gap:1rem;position:relative}.Edit-module__wrapper___phSAW h2{margin-bottom:.25rem}.Edit-module__wrapper___phSAW input{max-width:400px}.Edit-module__wrapper___phSAW .Edit-module__grid___3jF0A{display:grid;gap:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Edit-module__wrapper___phSAW",
	"grid": "Edit-module__grid___3jF0A"
};